import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductsService } from '../products.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  userCont:object[] = [];
  userData = new FormGroup({

    postId:new FormControl(1),
    id:new FormControl(),
    name:new FormControl('', Validators.required),
    email:new FormControl('', Validators.required),
    body:new FormControl('', Validators.required),

  });



  addPost()
  {

    // this.AllComments.push(this.userData.value);
    this.AllComments.splice(0,0,this.userData.value);
    localStorage.setItem('userData',JSON.stringify(this.AllComments));
    }



  productDetails:any = {};
  AllComments = [];
  ind;

  constructor(_ActivatedRoute:ActivatedRoute,public _ProductsService:ProductsService) {

    if(localStorage.getItem('userData'))
    {
      this.AllComments=JSON.parse(localStorage.getItem('userData'))
    }

    this.ind = _ActivatedRoute.snapshot.paramMap.get("id");


    this._ProductsService.getAllComments(this.ind).subscribe( (da) => {

      this.AllComments = da ;

     } )
     this._ProductsService.getOnePost(this.ind).subscribe( (d) => {

      this.productDetails = d;

     } )




   }

  ngOnInit(): void {


  }


}

